Alpine.directive('inview', (el, { expression }, { evaluate }) => {
    let lastState = null;
    let stableTimer = null;

    const observer = new IntersectionObserver(([entry]) => {
        const isVisible = entry.isIntersecting;

        clearTimeout(stableTimer);

        stableTimer = setTimeout(() => {
            if (lastState === isVisible) return;

            lastState = isVisible;
            evaluate(`${expression}(${isVisible})`);
        }, 100);
    });

    observer.observe(el);
});

Alpine.directive('inview-once', (el, { expression }, { evaluate }) => {
    let activated = false;

    const observer = new IntersectionObserver(([entry]) => {
        if (activated) return;

        if (entry.isIntersecting) {
            activated = true;
            evaluate(`${expression} = true`);
            observer.disconnect();
        }
    });

    observer.observe(el);
});
